import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import DatePicker, { registerLocale } from 'react-datepicker'
import { arSA, enUS } from 'date-fns/locale'
import 'react-datepicker/dist/react-datepicker.css'

registerLocale('ar', arSA)
registerLocale('en', enUS)

const toDate = value => {
  if (!value) return null
  const d = new Date(value)
  return Number.isNaN(d.getTime()) ? null : d
}

const RejectBookingModal = ({ bookingData, onConfirm, onCancel, loading }) => {
  const { t, i18n } = useTranslation()
  const isArabic = i18n.language === 'ar'

  const [blockVehicle, setBlockVehicle] = useState(true)
  const [from, setFrom] = useState(toDate(bookingData?.rentalStartDate))
  const [to, setTo] = useState(toDate(bookingData?.rentalEndDate))

  const rangeInvalid = blockVehicle && (!from || !to || to <= from)

  const handleSubmit = () => {
    if (rangeInvalid) return
    onConfirm(blockVehicle && from && to ? { unavailableFrom: from.toISOString(), unavailableTo: to.toISOString() } : {})
  }

  const pickerProps = {
    showTimeSelect: true,
    timeFormat: 'HH:mm',
    timeIntervals: 30,
    dateFormat: 'dd/MM/yyyy HH:mm',
    locale: isArabic ? 'ar' : 'en',
    className: 'block w-full shadow-sm focus:ring-dark-500 focus:border-dark-500 sm:text-sm border-gray-300 rounded-md',
    popperPlacement: 'bottom-start',
  }

  return (
    <div className="p-6 space-y-4">
      <label className="flex items-start gap-2 text-sm text-gray-700">
        <input
          type="checkbox"
          checked={blockVehicle}
          onChange={e => setBlockVehicle(e.target.checked)}
          className="mt-0.5 rounded border-gray-300 text-dark-600 focus:ring-dark-500"
        />
        <span>{t('booking.rejectModal.markUnavailable')}</span>
      </label>

      {blockVehicle && (
        <div className="space-y-4" dir={isArabic ? 'rtl' : 'ltr'}>
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{t('booking.rejectModal.unavailableFrom')} *</label>
            <div className="max-w-xs">
              <DatePicker selected={from} onChange={setFrom} {...pickerProps} />
            </div>
          </div>

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">{t('booking.rejectModal.unavailableTo')} *</label>
            <div className="max-w-xs">
              <DatePicker selected={to} onChange={setTo} minDate={from} {...pickerProps} />
            </div>
          </div>

          {rangeInvalid && <div className="text-sm text-red-500">{t('booking.rejectModal.invalidRange')}</div>}
        </div>
      )}

      <div className="flex justify-end gap-3 pt-2">
        <button type="button" onClick={onCancel} disabled={loading} className="rounded-md border border-gray-300 bg-white px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
          {t('booking.rejectModal.cancel')}
        </button>
        <button
          type="button"
          onClick={handleSubmit}
          disabled={loading || rangeInvalid}
          className="rounded-md bg-red-600 px-4 py-2 text-sm text-white hover:bg-red-700 disabled:opacity-50"
        >
          {loading ? t('booking.rejectModal.rejecting') : t('booking.rejectModal.confirm')}
        </button>
      </div>
    </div>
  )
}

export default RejectBookingModal
